module.exports = __webpack_public_path__ + "static/media/attr_sum_insured.953d519f.svg";